import Vue from 'vue';
export default Vue.extend({
    name: 'SwiperSlide',
    props: {
        tag: {
            type: String,
            default: 'div'
        },
        swiperRef: {
            type: Object,
            required: false
        },
        zoom: {
            type: Boolean,
            default: undefined
        },
        virtualIndex: {
            type: [String, Number],
            default: undefined
        }
    },
    render(createElement) {
        return createElement(this.tag, { class: 'swiper-slide' }, this.$slots.default);
    },
    created() {
        this.$emit('needUpdate');
    }
});
